import { Manage_consent_service } from "../services/Manage_consent.service";
import { MessageBox, Loading } from 'element-ui';
import Cookie from "cookies-js";
const moment = require('moment')

const state = {
    content_th: '',
    content_en: '',
    updated_at: '',
    updated_by: ''
}

const actions = {
    
    async getSecurity({ commit }) {
        let result = await Manage_consent_service.getSecurity()
        commit('SET_DATA', result.data.result[0])
    },

    async saveSecurity({commit}, formdata){
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let result = await Manage_consent_service.saveSecurity(formdata)
        if (result.status == 200) {
            state.updated_at = moment()
            let user_nbtc = Cookie.get('user_nbtc')
            let json_cookie = JSON.parse(user_nbtc);
            state.updated_by = json_cookie.fullname
            setTimeout(function() { loadingInstance.close() }, 250)
            MessageBox.confirm('บันทึกเสร็จสิ้น', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            })
        } else {
            setTimeout(function() { loadingInstance.close() }, 250)
            MessageBox.confirm('เกิดข้อผิดพลาด ไม่สามารถบันทึกได้ กรุณาลองใหม่อีกครั้ง', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'fail'
            })
        }
    }
}

const mutations = {
    SET_DATA(state, data){
        state.content_th = data.content_th
        state.content_en = data.content_en
        state.updated_at = data.updated_at
        state.updated_by = data.first_name + ' ' + data.last_name
    }
}

export const SecurityPolicyStore = {
    namespaced: true,
    state,
    actions,
    mutations
}